import React from "react";
import styled from "styled-components";

export const Badge = ({color, ...props}) => {
	return (
		<Wrapper className={"badge " + color}>
			{props.children}
		</Wrapper>
	);
};

const Wrapper = styled.div`
&				{display:inline-flex; align-items:center; justify-content:center; padding:6px; border-radius:6px; line-height:1.2}
&.red			{background-color:#fff0f0; color:var(--red)}
&.yellow		{background-color:rgba(255,138,30,0.1); color:#ff8a1e !important}
&.blue			{background-color:#ecf1ff; color:var(--blue)}
&.green			{background-color:#e5f6f2; color:var(--green)}
&.purple		{background-color:#eae6f6; color:var(--purple)}
&.gray			{background-color:#f3f3f4; color:#838791}
`;

export default Badge;